import React from 'react';
import Select from 'react-select';
import { FieldLabel } from './NodeFormKit';

export const TRIGGER_TYPES = [
  { label: 'Mensaje', value: 'message' },
  { label: 'Evento', value: 'event' },
  { label: 'Flujos', value: 'flows' },
];

const TriggerTypeField = ({
  value,
  handleInputChange,
  setValue,
  isDark,
  customStyles,
  customStylesDark,
  label = 'Tipo de respuesta:',
}) => {
  const current =
    TRIGGER_TYPES.find((option) => option.value === (value || 'message')) ||
    TRIGGER_TYPES[0];

  const handleChange = (option) => {
    const next = option?.value || 'message';
    if (typeof setValue === 'function') {
      setValue('trigger_type', next, { shouldDirty: true });
    }
    handleInputChange('trigger_type', next);
    if (next !== 'flows') {
      handleInputChange('flow_template_id', null);
      handleInputChange('flow_template_name', null);
    }
  };

  return (
    <>
      <FieldLabel htmlFor="trigger_type">{label}</FieldLabel>
      <div className="su-control-group d-flex">
        <Select
          styles={isDark == 'true' ? customStylesDark : customStyles}
          className="form-control basic-multi-select"
          placeholder="Seleccione..."
          name="trigger_type"
          value={current}
          onChange={handleChange}
          options={TRIGGER_TYPES}
          classNamePrefix="select"
          noOptionsMessage={() => 'Sin opciones'}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
        />
      </div>
    </>
  );
};

export default TriggerTypeField;
